import request from '@/sheep/request';
import type { GeoData } from '@/utils/location'

// 分类
export interface Wishes {
	id : string
	userId : number
	nickname : string
	avatar : string
	picUrl ?: string
	categoryId ?: number
	title ?: string
	description ?: string
	status ?: number
	isPublic ?: boolean
	isTimeCapsule ?: boolean
	capsuleOpenDate ?: string
	targetDate ?: string
	isRedeem ?: boolean
	isAiProcessed ?: boolean
	isOwner ?: boolean
	likeCount ?: number
	guardCount ?: number
	commentCount ?: number
	// 完整的地理位置信息（后端逆地理编码返回）
	geo ?: GeoData
	attention ?: any
	owner : any
	like : any
	guard : any
	createTime : any
	subjectId ?: string | number
	placeId ?: string
	province ?: string
	city ?: string
	district ?: string
	analysis ?: any
	place ?: any
}


// 检查敏感词
export const checkSensitiveWord = async (content : string) => {
	return request({
		url: '/wish/wishes/check-word',
		method: 'POST',
		data: { content },
		custom: {
			showLoading: false,
			showSuccess: false,
		}
	});
}

// 创建愿望
// auth 默认为 true（未登录弹登录拦截）；匿名解锁发布场景传 false，由后端校验通行证
export const publishWish = async (data : any, auth : boolean = true) => {
	return request({
		url: '/wish/wishes/publish',
		method: 'POST',
		data,
		custom: {
			auth,
			showSuccess: true,
			successMsg: '心愿记录完成'
		},
	});
}

// 查询愿望列表
export const getWishesPage = async (params : any) => {
	return request({
		url: '/wish/wishes/page',
		method: 'GET',
		params
	});
}

// 查询愿望列表
export const getWishesByUserPage = async (params : any) => {
	return request({
		url: '/wish/wishes/my/page',
		method: 'GET',
		params,
		custom: {
			auth: true
		},
	});
}
export const getWishesByUserList = async () => {
	return request({
		url: '/wish/wishes/my/list',
		method: 'GET',
		custom: {
			auth: true
		},
	});
}

// 查询愿望列表 - 根据分类
export const getWishesByCategoryList = async (params : any) => {
	return request({
		url: '/wish/wishes/category/page',
		method: 'GET',
		params
	});
}

// 查询愿望详情
export const getWishesDetail = async (id : number) => {
	return request({
		url: '/wish/wishes/get',
		method: 'GET',
		params: { id }
	});
}

// 点赞
export const likeWish = async (params : any) => {
	return request({
		url: '/wish/wishes/like',
		method: 'GET',
		params: params,
		custom: {
			auth: true,
			showLoading: false,
		}
	});
}

// 守护
export const guardWish = async (params : any) => {
	return request({
		url: '/wish/wishes/guard',
		method: 'GET',
		params: params,
		custom: {
			auth: true,
			showLoading: false,
		}
	});
}

export const flyWish = async (params : any) => {
	return request({
		url: '/wish/wishes/fly',
		method: 'GET',
		params: params,
		custom: {
			auth: true,
			showLoading: false,
		}
	});
}

// 关注用户
// export const attentionUser = async (params: any) => {
// 	return request({
// 		url: '/wish/member/attention',
// 		method: 'GET',
// 		params: params,
// 		custom: {
// 			showLoading: false,
// 			auth: true,
// 		}
// 	});
// }